import React from 'react';

import RuleEditorPanels from './RuleEditorPanels';

const RuleEditor = (): JSX.Element => {
  return <RuleEditorPanels />;
};

export default RuleEditor;
